import {
  ReactionJSONProps,
  Reaction,
  UserMessage,
} from 'api/conversations/types';
import { HttpClient } from 'api/http-client';

class CommentsHttpClient extends HttpClient {
  public update(
    commentId: number,
    comment: Pick<UserMessage, 'content'>,
  ): Promise<null> {
    return this.put<UserMessage, Pick<UserMessage, 'content'>, null>(
      `/comments/${commentId}`,
      comment,
    );
  }

  public async remove(commentId: number): Promise<null> {
    return this.delete<UserMessage, null>(`/comments/${commentId}`);
  }

  public addReaction(
    commentId: number,
    reactionType: Reaction,
  ): Promise<ReactionJSONProps> {
    return this.post<ReactionJSONProps, ReactionJSONProps, ReactionJSONProps>(
      `/comments/${commentId}/add-reaction`,
      {
        reactionType,
      },
    );
  }
}

export { CommentsHttpClient };

export const CommentsAPI = new CommentsHttpClient();
